import script from "./OcrScanLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./OcrScanLoading.vue?vue&type=script&setup=true&lang=js"

import "./OcrScanLoading.vue?vue&type=style&index=0&id=cdc16bc0&scoped=true&lang=less"
import "./OcrScanLoading.vue?vue&type=style&index=1&id=cdc16bc0&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdc16bc0"]])

export default __exports__